// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyD3N5FCEWDhtEZEuXOSY2JPol6F-p0txXI",
    authDomain: "rotating3dmockups.firebaseapp.com",
    projectId: "rotating3dmockups",
    storageBucket: "rotating3dmockups.appspot.com",
    messagingSenderId: "1016576986119",
    appId: "1:1016576986119:web:f2bfaec5f1c41241ec6ea2",
    measurementId: "G-Y17WY0JPHT"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

// Function to upload file to Firebase Storage
export async function uploadFile(file) {
  return new Promise((resolve, reject) => {
    // Create an image element
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      // Create canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Set desired dimensions
      const MAX_WIDTH = 1125;
      const MAX_HEIGHT = 2436;

      canvas.width = MAX_WIDTH;
      canvas.height = MAX_HEIGHT;

      // Draw the image on canvas and resize it
      ctx.drawImage(img, 0, 0, MAX_WIDTH, MAX_HEIGHT);

      // Convert canvas to blob
      canvas.toBlob((blob) => {
        // Continue with the upload process using the resized image
        const resizedFile = new File([blob], file.name, {
          type: 'image/jpeg',
          lastModified: Date.now()
        });

        // Create a storage reference
        const storageRef = ref(storage, `uploads/${resizedFile.name}`);
        // Start the file upload
        const uploadTask = uploadBytesResumable(storageRef, resizedFile);

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on('state_changed',
          (snapshot) => {
            // Optional: Get upload progress
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
          },
          (error) => {
            // Handle unsuccessful uploads
            console.error('Upload failed:', error);
            reject(error);
          },
          () => {
            // Handle successful uploads on complete
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              console.log('File available at', downloadURL);
              resolve(downloadURL);
            });
          }
        );
      }, 'image/jpeg');
    };
  });
}


// Function to save file metadata to Firestore
export async function saveFileMetadataToFirestore(fileData) {
  try {
    const docRef = await addDoc(collection(db, "files"), fileData);
    console.log("Document written with ID: ", docRef.id);
    return docRef.id;
  } catch (e) {
    console.error("Error adding document: ", e);
  }
}
